import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('waflow_token'));
  const [admin, setAdmin] = useState(() => {
    try { return JSON.parse(localStorage.getItem('waflow_admin')); } catch { return null; }
  });

  const login = useCallback(async (email, password) => {
    const baseUrl = `${window.location.origin}/api`;
    const { data } = await axios.post(`${baseUrl}/auth/login`, { email, password }, { timeout: 15000 });
    localStorage.setItem('waflow_token', data.token);
    localStorage.setItem('waflow_admin', JSON.stringify(data.admin));
    setToken(data.token);
    setAdmin(data.admin);
    api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('waflow_token');
    localStorage.removeItem('waflow_admin');
    setToken(null);
    setAdmin(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
